import React, { type ReactNode } from 'react'
import { ProgressBar } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'

// The table variant sits in a `td`, which already gives the bar a block context to fill, so a cap is enough.
const tableWidthCss = css`
  max-width: 170px;
`

// The desktop list sizes the bar to its own content, so a cap alone would shrink it to the width of the
// message text. The width is stated outright, and capped so it still fits narrower containers on mobile.
const defaultWidthCss = css`
  max-width: 100%;
  width: 300px;
`

type Props = {
  percentComplete: number
  label?: ReactNode
  isTableRow?: boolean
}

export default function UploadProgressBar({ percentComplete, label, isTableRow }: Props): JSX.Element {
  const [t] = useTranslation()
  const adjustedPercent = Math.max(1, percentComplete)

  const widthCss = isTableRow ? tableWidthCss : defaultWidthCss

  return (
    <div data-testid="upload-progress-bar" css={widthCss}>
      <ProgressBar
        value={adjustedPercent}
        message={label ?? t('group-management.importing-tree.heading', { percentage: adjustedPercent })}
      />
    </div>
  )
}
